import type { AvailableLegalCountryCode } from '@repo/shared-kit/constants/countries';

// Markets gated by the `ab-test--sdd-new-markets` A/B test (50/50).
// Existing-market call sites (FR, DE, IT, ES) must remain unconditional;
// only the new-market branch sits behind the flag.
export const SDD_NEW_MARKETS = [
  'BE',
  'NL',
  'AT',
  'PT',
] as const satisfies readonly AvailableLegalCountryCode[];

export type SddNewMarket = (typeof SDD_NEW_MARKETS)[number];

const MARKET_SET: ReadonlySet<string> = new Set(SDD_NEW_MARKETS);

export function isSddNewMarket(country: string | null | undefined): country is SddNewMarket {
  return country !== null && country !== undefined && MARKET_SET.has(country);
}
